import * as React from 'react';
import { TileWrapper } from 'app/components/tile-wrapper/tile-wrapper';
import { ExcelMappingsProps } from '../types';
import { ExcelMappingsItem } from './excel-mappings-item';
import styles from './excel-mappings-container.scss';

export const ExcelMappingsContainer = (props: ExcelMappingsProps) => {
  const { companyReportItem: { excelMapping } = {}, translation } = props;

  return <TileWrapper>
    <div className={styles.container}>
      {excelMapping.length > 0
        ? excelMapping.map(item =>
          <ExcelMappingsItem
            key={item.id}
            value={item}
            {...props} />)
        : <p className="no-content">{translation.excel_mappings_no_data}</p>}
    </div>
  </TileWrapper>;
};
